<template>
    <div v-if="loading" class="loading xy-center" style="height: 100vh">
        <i class="el-icon-loading" style="font-size: 40px"></i>
    </div>
    <div v-else class="print-dont-rem">
        <div class="title text-center font-size22 font-medium">
            {{model.basic.ExamName}}
        </div>
        <div class="print-info">
            <div class="block-item">
                <info-item title="考试名称">{{model.basic.ExamName}}</info-item>
                <info-item title="总分">{{model.basic.TotalScore}}</info-item>
                <info-item title="所属分类">{{model.basic.ClassName}}</info-item>
            </div>
            <div class="block-item">
                <info-item title="考试时间">{{model.basic.BeginTime | sliceTime}} 至 {{model.basic.EndTime | sliceTime}}</info-item>
                <info-item title="试题量">{{model.basic.SubjectNum}}</info-item>
                <info-item title="发布者">{{model.basic.UserName || '--'}}</info-item>
            </div>
            <div class="block-item">
                <info-item title="考试时长">{{model.basic.ExamTimeName==='0分钟'?'不限时长':model.basic.ExamTimeName}}</info-item>
                <info-item title="考试次数">{{model.basic.ExamNumName}}</info-item>
                <info-item title="发布时间">{{model.basic.AddTime | sliceTime}}</info-item>
            </div>
        </div>
        <result-paper-title>整体情况</result-paper-title>
        <el-table class="zt-table" border :data="ztTable">
            <el-table-column label="应考人数" prop="ComeNum" align="center"/>
            <el-table-column label="实考人数" prop="SolidNum" align="center"/>
            <el-table-column label="缺考人数" prop="MissingNum" align="center"/>
            <el-table-column label="最高分" prop="Max" align="center"/>
            <el-table-column label="最低分" prop="Min" align="center"/>
            <el-table-column label="平均分" prop="Avg" align="center"/>
        </el-table>
        <result-paper-title>分数段统计</result-paper-title>
        <div id="score-interval">
        </div>
        <result-paper-title v-show="model.dic.length > 0">用户组统计</result-paper-title>
        <div id="user-group" :style="userGroupStyle" v-show="model.dic.length > 0">
        </div>

        <result-paper-title v-if="model.AnswerView.fewlist||model.AnswerView.manylist">单题统计</result-paper-title>
        <div class="most-right single-que" v-if="model.AnswerView.manylist">
            <div class="lite-title font-medium c-2F3134 font-size16">最多做对</div>
            <div class="xy-start">
                <div class="auto-grow">
                    <question-show-b :orgin-obj="model.AnswerView.manylist">
                    </question-show-b>
                </div>
                <dash-board :data="model.AnswerView.mannyMax" name="做对" unit="次" :max-data="examNum"></dash-board>
            </div>
        </div>
        <div class="most-right single-que" style="margin-top: 30px" v-if="model.AnswerView.fewlist">
            <div class="lite-title font-medium c-2F3134 font-size16">最多做错</div>
            <div class="xy-start">
                <div class="auto-grow">
                    <question-show-b :orgin-obj="model.AnswerView.fewlist" >
                    </question-show-b>
                </div>
                <dash-board :data="model.AnswerView.fewMin" name="做错" unit="次" :max-data="examNum"></dash-board>
            </div>
        </div>

        <result-paper-title>最好成绩</result-paper-title>
        <el-table class="zt-table" border :data="[model.rank]">
            <el-table-column label="用户名"  prop="UserName"  align="center" :formatter="defaultVal"/>
            <el-table-column label="真实姓名" prop="RealName" align="center" :formatter="defaultVal"/>
            <el-table-column label="所属用户组" prop="GroupName" align="center" :formatter="defaultVal"/>
            <el-table-column label="考试次数" prop="ExamNum" align="center" :formatter="defaultVal"/>
            <el-table-column label="考试时间" prop="BeginTime" align="center" :formatter="timeNoSec" />
            <el-table-column label="答卷时长" prop="ExamTime" align="center" :formatter="secFormat"/>
            <el-table-column label="成绩" prop="ExamScore" align="center" :formatter="defaultVal"/>
        </el-table>
    </div>
</template>

<script>
import ResultPaperTitle from "@/components/manager/result-print/ResultPaperTitle";
import * as echarts from "echarts";
import DashBoard from "@/components/manager/result-print/DashBoard";
import QuestionShowB from "@/components/manager/result-print/QuestionShowB";
import { GetReport } from "@/api/manage";
import tableFormatter from "@/mixins/tableFormatter";

const InfoItem = {
    name: "info-item",
    functional: true,
    render(h, context) {
        let titles = context.props.title.split("")
        let i = titles.length - 1;
        titles[i] = titles[i] + "："
        let label = h("div", { class: "label" }, titles.map(el => h("span", el)))
        return h("div", { class: "xy-start info-item" }, [label, ...context.children])
    },
    props: ["title"]
}
export default {
    name: "result-print",
    components: {
        QuestionShowB,
        DashBoard,
        ResultPaperTitle,
        InfoItem: InfoItem
    },
    mixins: [tableFormatter],
    data() {
        return {
            loading: true,
            baseScoreUser: [{
                name: "av13345",
                realName: "李四",
                group: "产品事业部",
                examTime: 1,
                examDate: "2021-10-10 10:10",
                answerTime: 50,
                score: 95
            }],
            maxRightMan: 100,
            quesData: {
                subjectId: "df8b2a88-b84d-48c8-818c-90e07f871340",
                subjectTypeId: "ab3fb9af-fdac-42f9-9561-d30201c2a015",
                subjectName: "医学平台拥有试题总量？",
                subjectType: 1,
                classId: 1616,
                groupLevelIdStr: ",1936,1937,2301,2302,2303,2304,2305,",
                hardlevel: 1,
                useType: 1,
                skillPoint: "",
                rankNum: 1,
                rankStyle: 0,
                content: "医学平台拥有试题总量？",
                subjectAnswerData: [{
                    answerId: "6bfedbfb-dd2a-4e3b-a0a3-191abe9fb8e0",
                    subjectId: "df8b2a88-b84d-48c8-818c-90e07f871340",
                    rankNum: 1,
                    rankStyle: null,
                    content: "100W",
                    isRight: 0,
                    isIncludeRight: 0,
                    isMultiple: 0
                }, {
                    answerId: "35a23d04-eca9-4287-bb8e-fe79695d8d8f",
                    subjectId: "df8b2a88-b84d-48c8-818c-90e07f871340",
                    rankNum: 2,
                    rankStyle: null,
                    content: "200W",
                    isRight: 0,
                    isIncludeRight: 0,
                    isMultiple: 0
                }, {
                    answerId: "afd1cf51-5368-4d29-8527-b3b36ef7a6db",
                    subjectId: "df8b2a88-b84d-48c8-818c-90e07f871340",
                    rankNum: 3,
                    rankStyle: null,
                    content: "500W",
                    isRight: 0,
                    isIncludeRight: 0,
                    isMultiple: 0
                }, {
                    answerId: "f07b636c-c75f-4c0d-bf5d-46885051f39f",
                    subjectId: "df8b2a88-b84d-48c8-818c-90e07f871340",
                    rankNum: 4,
                    rankStyle: null,
                    content: "1200W",
                    isRight: 1,
                    isIncludeRight: 0,
                    isMultiple: 0
                }],
                analysis: "1200W试题",
                scoreRole: 0,
                answerRank: 0,
                caseRole: 0,
                addUser: "896b6259434b4015a4576e52b3c7977c",
                addTime: "0001-01-01 00:00:00",
                subjectState: 1,
                perSubjectScore: 10,
                childExamPaperSubject: null,
                parentId: null,
                inputState: 0,
                trainClassId: 0,
                subjectTime: "0001-01-01 00:00:00",
                importExamPaperId: null,
                importExamPaperName: null,
                authority: 0
            },
            model: {}
        }
    },
    computed: {
        ztTable() {
            return [this.model.score]
        },
        // 分数段间隔
        scoreInput() {
            return 20;
        },
        // 用户组样式
        userGroupStyle() {
            return {
                height: (this.model.dic.length * 100 + 150) + "px"
            }
        },
        // 参考人数
        examNum() {
            return parseInt(this.model.score.SolidNum)
        }
    },
    mounted() {
        this.loadData().then(() => {
            this.$nextTick(() => {
                this.scoreBar = echarts.init(document.getElementById("score-interval"));
                this.userBar = echarts.init(document.getElementById("user-group"));
                this.setScoreBar()
                this.setUserBar()
            })
        })
    },
    beforeDestroy() {
        this.scoreBar.dispose()
        this.userBar.dispose()
    },
    filters: {
        sliceTime(timeStr) {
            return timeStr.slice(0, 16)
        }
    },
    methods: {
        strfunc(i) {
            if (i === null) {
                return "--"
            } else {
                return i
            }
        },
        loadData() {
            this.loading = true;
            let { examId, totalScore } = this.$route.query;
            return GetReport({
                ExamId: examId,
                TotalScore: totalScore
            }).then(data => {
                this.model = data;
                this.loading = false;
            })
        },
        setScoreBar() {
            let labels = []
            for (let i = 0; i < this.model.number.length; i++) {
                let b = (i + 1) * this.scoreInput
                let a = b - this.scoreInput;
                labels.push(`${a}-${b}`)
            }

            let data = this.model.number
            this.scoreBar.setOption({
                grid: {
                    top: "14%",
                    left: "5%",
                    right: "10%",
                    bottom: "8%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: { type: "cross" }
                },
                xAxis: {
                    data: labels,
                    axisTick: { show: false },
                    axisLine: { show: false },
                    name: "分数"
                },
                yAxis: {
                    name: "人数",
                    axisLine: { show: false },
                    axisLabel: { show: false },
                    axisTick: { show: false },
                    splitLine: {
                        lineStyle: {
                            color: ["#E5E8EC"],
                        }
                    }
                },
                series: [
                    {
                        name: "人数",
                        type: "bar",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: {
                                    type: "linear",
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: "#4283FF" // 0% 处的颜色
                                    }, {
                                        offset: 1, color: "#BFD5FF" // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                },
                                label: {
                                    show: true, // 开启显示
                                    position: "top", // 在上方显示
                                    textStyle: { // 数值样式
                                        color: "#32353A",
                                        fontSize: 16
                                    }
                                }
                            },
                            borderRadius: [5, 5, 5, 5]
                        },
                        data
                    }
                ]
            });
        },
        setUserBar() {
            let labels = this.model.dic.map(el => {
                return Object.keys(el)[0];
            })
            let data = this.model.dic.map(el => {
                return Object.values(el)[0];
            })
            this.userBar.setOption({
                grid: {
                    top: "14%",
                    left: "5%",
                    right: "10%",
                    bottom: "8%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: { type: "cross" }
                },
                xAxis: {
                    type: "value",
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: {
                            color: "#E5E8EC"
                        }
                    },
                    axisLabel: { color: "#32353A" },
                    splitLine: { show: false },
                    name: "成绩"
                },
                yAxis: {
                    data: labels,
                    name: "用户组",
                    type: "category",
                    axisLine: { show: false },
                    axisLabel: { color: "#72777F" },
                    axisTick: { show: false },
                },
                series: [
                    {
                        name: "成绩",
                        type: "bar",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: {
                                    type: "linear",
                                    x: 0,
                                    y: 0,
                                    x2: 1,
                                    y2: 0,
                                    colorStops: [{
                                        offset: 0, color: "#6A42FF" // 0% 处的颜色
                                    }, {
                                        offset: 1, color: "#CFBFFF" // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                },
                                label: {
                                    show: true, // 开启显示
                                    position: "right", // 在上方显示
                                    textStyle: { // 数值样式
                                        color: "#32353A",
                                        fontSize: 16
                                    }
                                },
                                barBorderRadius: [0, 500, 500, 0]
                            },
                        },
                        data
                    }
                ]
            });
        }
    },
}
</script>

<style scoped lang="less">
.print-dont-rem {
    background: #FFFFFF;
    padding-bottom: 68px;

    .title {
        padding-top: 30px;
        padding-bottom: 40px;
    }

    .print-info {
        display: flex;
        justify-content: space-evenly;

        .info-item {
            .label {
                flex-shrink: 0;
                width: 80px;
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                color: #72777F;
                line-height: 20px;
            }

            margin-top: 20px;
            line-height: 20px;
            font-size: 14px;
        }
    }

    .zt-table {
        width: 1079px;
        margin: 0 auto;
    }

    ::v-deep th {
        background: #F9F9F9;
        font-weight: 500;
        color: #32353A;
    }

    #score-interval {
        width: 1080px;
        height: 395px;
        border-radius: 0 0 8px 8px;
        border: 1px solid #E5E8EC;
        margin: 0 auto;
    }

    #user-group {
        width: 1080px;
        height: 599px;
        border-radius: 0 0 8px 8px;
        border: 1px solid #E5E8EC;
        margin: 0 auto;
    }

    .single-que {
        margin: 0 30px;
        background: #F4F5F6;
        padding: 30px 86px 56px 30px;

        .lite-title {
            position: relative;
            padding-left: 10px;

            &:before {
                content: "";
                width: 4px;
                height: 4px;
                position: absolute;
                left: 0;
                top: calc(50% - 2px);
                border-radius: 50%;
                background: #256CF4;
            }
        }
    }
}

@media screen and (min-width: 1441px) {
    .print-dont-rem {
        width: 1440px;
        background: white;
        border-radius: 12px;
        margin: 20px auto;
    }
}

@media screen and (max-width: 1440px) {
    .print-dont-rem {
        width: 100%;
        background: white;
    }
}
</style>
